<div class="container-sm-fluid pt-3 px-sm-4">
    <dx-tabs
        keyExpr="id"
        [items]="tabs"
        [selectedItemKeys]="selectedTabKeys"
        [showNavButtons]="false"
        stylingMode="primary"
        (onItemClick)="onTabClick($event.itemData.id)"
    ></dx-tabs>
</div>

@if (selectedTabKeys[0] === 'charts') {
    <app-blocked-stock-charts></app-blocked-stock-charts>
} @else if (selectedTabKeys[0] === 'score') {
    <app-blocked-stock-score></app-blocked-stock-score>
} @else if (selectedTabKeys[0] === 'data') {
    <app-blocked-stock-data></app-blocked-stock-data>
}
